import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import OsteoLogo from '../components/Logo'

const ERRORS = {
  oauth_denied: 'Sign-in was cancelled.',
  not_authorised: 'Your Google account is not authorised for the design portal.',
  invalid_state: 'Sign-in session expired. Please try again.',
  server_error: 'A server error occurred. Please try again.',
}

export default function DesignLogin() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const [error, setError] = useState(null)

  useEffect(() => {
    const token = params.get('token')
    if (token) {
      sessionStorage.setItem('adminToken', token)
      navigate('/', { replace: true })
      return
    }
    const err = params.get('error')
    if (err) setError(ERRORS[err] ?? 'Sign-in failed. Please try again.')
    else if (sessionStorage.getItem('adminToken')) navigate('/', { replace: true })
  }, [params, navigate])

  function signIn() {
    // Full-window nav so Google can redirect back. ?redirect returns the callback
    // to THIS origin (design portal); the origin must be in the backend ALLOWED_ORIGINS.
    const apiBase = import.meta.env.VITE_API_BASE_URL || ''
    const redirect = encodeURIComponent(`${window.location.origin}/login`)
    window.location.href = `${apiBase}/api/admin/auth/google?redirect=${redirect}`
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="card max-w-sm w-full">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-5">
            <OsteoLogo size="md" />
          </div>
          <h2 className="text-base font-semibold text-gray-700">Design Portal</h2>
          <p className="text-gray-400 text-sm mt-0.5">STL Preview &amp; Illustration</p>
        </div>

        {error && (
          <div className="mb-5 flex items-start gap-2 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
            <svg className="w-4 h-4 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
            </svg>
            {error}
          </div>
        )}

        <button
          onClick={signIn}
          className="w-full flex items-center justify-center gap-3 px-4 py-3 border border-gray-300 rounded-lg bg-white hover:bg-gray-50 active:bg-gray-100 transition-colors font-medium text-gray-700 shadow-sm"
        >
          <GoogleIcon />
          Sign in with Google
        </button>

        <p className="mt-4 text-center text-xs text-gray-400">
          Authorised Osteo3d designers only.
        </p>
      </div>
    </div>
  )
}

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908C16.658 14.013 17.64 11.705 17.64 9.2z" />
      <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z" />
      <path fill="#FBBC05" d="M3.964 10.71A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 000 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" />
      <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.958L3.964 6.29C4.672 4.163 6.656 3.58 9 3.58z" />
    </svg>
  )
}
